<template>
  <div>
    <el-card class="box-card">
      <el-form :model="editData" ref="editDataRef" label-width="110px">
        <el-form-item label="姓名" class="addAdminForm">
          <el-input v-model="editData.name" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item label="职务" class="addAdminForm">
          <el-input v-model="editData.position" placeholder="请输入职务"></el-input>
        </el-form-item>
        <el-form-item label="学历" class="addAdminForm">
          <el-input v-model="editData.education" placeholder="请输入学历"></el-input>
        </el-form-item>
        <el-form-item label="头像" class="addAdminForm">
          <el-input v-model="editData.picurl" placeholder="请输入头像"></el-input>
        </el-form-item>
        <el-form-item label="排序" class="addAdminForm">
          <el-input v-model="editData.listorder" placeholder="请输入排序"></el-input>
        </el-form-item>
        <el-form-item class="mt20">
          <el-button type="primary" @click="clicksave">保存</el-button>
          <el-button type="info" @click="clickreturn">返回</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
  },
  data () {
    return {
      editData: {
        id: '0',
        name: '',
        picurl: '',
        position: '',
        education: '',
        listorder:''
      }
    }
  },
  mounted () {
  },
  methods: {
    LoadData (row) {
      this.editData.id = row.Id
      this.editData.name = row.Name
      this.editData.picurl = row.Picurl
      this.editData.position = row.Position
      this.editData.education = row.Education
      this.editData.listorder = row.Listorder
    },
    clickreturn () {
      this.$emit('triggerFunc', '')
    },
    clicksave () {
      this.EditKgjtWebsiteExperts()
    },
    EditKgjtWebsiteExperts: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: that.editData.id,
        name: that.editData.name,
        picurl: that.editData.picurl,
        position: that.editData.position,
        education: that.editData.education,
        listorder: that.editData.listorder
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_EditKgjtWebsiteExperts, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCode(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-button--mini, .el-button--mini.is-round {
    padding: auto 5px;
}
.select{
   width: 365px;
}
</style>
